export enum UrlParams {
    LOCATION_ID = 'locationId',
    MOVE_ID = 'moveId',
    METRIC_NAME = 'metricName',
    TIME_PERIODS = 'timePeriods',
    RGD_DETAIL_CARD_ID = 'rgdDetailCardId',
    STORE_DETAIL_CARD_ID = 'storeDetailCardId',
    RGD_EXCEPTION_CARD_ID = 'rgdExceptionCardId',
    STORE_EXCEPTION_CARD_ID = 'storeExceptionCardId',
    ACTIVE_TIME_PERIOD = 'activeTimePeriod',
    ACTIVE_TIME_INDEX = 'activeTimeIndex',
}
